// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"TodoListEdit_checkbox__lNL-9"};